/**
 * Canonical numeric utility functions for currency/financial calculations.
 */

/**
 * Safely convert any value to a number.
 * Handles currency strings ("$1,234.56"), nulls, empty strings, etc.
 */
export const toNumber = (value: unknown): number => {
  if (value === '' || value == null) return 0
  if (typeof value === 'string') {
    const cleaned = value.replace(/[$,]/g, '')
    const n = parseFloat(cleaned)
    return Number.isFinite(n) ? n : 0
  }
  const n = Number(value)
  return Number.isFinite(n) ? n : 0
}

/**
 * Round to 2 decimal places (for currency).
 */
export const round2 = (n: number): number => Math.round((n + Number.EPSILON) * 100) / 100

/**
 * Round to 2 decimal places and return as fixed string.
 */
export const toFixed2 = (n: number): string => round2(n).toFixed(2)
